module.exports = __webpack_public_path__ + "static/media/link-app@2x.4dc7b7c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/link-app@2x.png
// module id = 820
// module chunks = 0